import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IServerSideGetRowsParams } from 'ag-grid-enterprise';
import { forkJoin } from 'rxjs';
import { SiteUser } from 'src/app/classes/models';
import { AuthService } from 'src/app/services/auth.service';
import { GridService } from 'src/app/services/grid.service';
import { SiteService } from 'src/app/services/site.service';
import { UtilityService } from 'src/app/services/utility.service';

import { BaseGridComponent } from '../base-grid/base-grid.component';

@Component({
  selector: 'app-site-users-grid',
  templateUrl: '../base-grid/base-grid.component.html',
  styleUrls: [
    '../base-grid/base-grid.component.less',
    './site-users-grid.component.less'
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SiteUsersGridComponent
  extends BaseGridComponent
  implements OnInit
{
  constructor(
    private SiteService: SiteService,
    protected override GridService: GridService,
    protected override UtilityService: UtilityService,
    protected override AuthService: AuthService
  ) {
    super(GridService, UtilityService, AuthService);
  }

  override ngOnInit(): void {
    this.gridPrimaryKeyFieldName = 'id';
    this.gridType = 'SiteUser';
    this.rowModelType = 'serverSide';

    this.additionalQueryData = {
      attributes: ['id', 'SiteId', 'UserId', 'isPrimary', 'shouldNotify']
    };

    this.ServerSideDataSource = {
      getRows: (params: IServerSideGetRowsParams) => {
        const { request } = params;

        const queryObject = this.constructGridQuery({ request });
        const countQueryObject = this.constructGridQuery(
          { request },
          { isCountQuery: true }
        );

        forkJoin([
          this.SiteService.getSiteUsers(queryObject),
          this.SiteService.getSiteUserCount(countQueryObject)
        ]).subscribe({
          next: ([SiteUsers, siteUserCount]) => {
            const successObject: { rowData: SiteUser[]; rowCount: number } = {
              rowData: SiteUsers,
              rowCount: siteUserCount
            };

            params.success(successObject);
          },
          error: (err) => {
            console.log(err);
            params.fail();
          }
        });
      }
    };
  }
}
